<template>
  <div
    class="bundle-card"
    :class="{ 'bundle-card--selected': selected, 'bundle-card--disabled': disabled }"
    role="button"
    tabindex="0"
    @click="onCardClick"
    @keydown.enter.prevent="!disabled && $emit('toggle')"
    @keydown.space.prevent="!disabled && $emit('toggle')"
  >
    <div class="bundle-card__content">
      <div class="bundle-card__text">
        <p class="bundle-card__price">{{ priceLabel }}</p>

        <div class="bundle-card__mid">
          <p class="bundle-card__sub-title">What you can include:</p>
          <p class="bundle-card__desc">{{ description }}</p>
        </div>
      </div>
    </div>

    <div class="bundle-card__footer">
      <LoginButton
        type="primary"
        class="bundle-card__select-btn"
        :disabled="disabled"
        @click="!disabled && $emit('toggle')"
      >
        Select
      </LoginButton>
    </div>
  </div>
</template>


<script>
import LoginButton from "../../../../login/components/LoginButton.vue";

export default {
  name: "BundleCard",
  props: {
    priceLabel: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoginButton,
  },
  emits: ["toggle"],
  methods: {
    onCardClick(e) {
      if (this.disabled) return;
      // If the click originated from the select button, ignore to avoid double toggle
      const fromSelectBtn = e && e.target && e.target.closest && e.target.closest('.bundle-card__select-btn');
      if (fromSelectBtn) return;
      this.$emit('toggle');
    }
  }
};
</script>

<style scoped>
.bundle-card {
  width: 217px;
  height: 255px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;

  padding: 24px 20px;
  border-radius: 10px;
  border: 1px solid #f2f2f2;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(26, 32, 44, 0.06);

  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  position: relative;
}

.bundle-card--disabled {
  cursor: not-allowed;
  border-color: #e0e0e0;
}

.bundle-card:not(.bundle-card--disabled):hover {
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(26, 32, 44, 0.1);
}

/* Disabled mask overlay – keep background but add a subtle veil */
.bundle-card--disabled::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  pointer-events: none;
}

.bundle-card--selected {
  border-color: #004879;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(26, 32, 44, 0.1);
}

.bundle-card__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 0;
}

.bundle-card__content p {
  margin: 0;
}

.bundle-card__text {
  width: 100%;
  display: grid;
  grid-template-rows: auto auto;
  row-gap: 20px;
  justify-items: center;
}

.bundle-card__mid {
  display: grid;
  grid-template-rows: auto auto;
  row-gap: 2px;
  justify-items: center;
}

.bundle-card__price {
  color: var(--SecondaryBlack, #666);
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  width: 166px;
  text-align: center;
}

.bundle-card__sub-title {
  color: var(--SecondaryBlack, #666);
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  width: 166px;
  text-align: center;
}

.bundle-card__desc {
  color: var(--VibrantDarkBlue, #004879);
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  width: 166px;
  text-align: center;
  white-space: pre-wrap;
  word-break: break-word;
}

/* When disabled, description text should not be blue */
.bundle-card--disabled .bundle-card__desc {
  color: #979797;
}

/* Disabled: title & subtitle also use grey */
.bundle-card--disabled .bundle-card__price,
.bundle-card--disabled .bundle-card__sub-title {
  color: #979797;
}

.bundle-card__footer {
  display: flex;
  justify-content: center;
  margin-top: 0;
  width: 100%;
}

.bundle-card__select-btn {
  width: 100%;
  height: 40px;
  border-radius: 4px !important;
  box-shadow: 0 1px 3px rgba(74, 74, 74, 0.25);
  font-family: Inter, sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  letter-spacing: 0.25px !important;
}

.bundle-card__select-btn,
.bundle-card__select-btn:hover,
.bundle-card__select-btn:focus,
.bundle-card__select-btn:active {
  background: #004879 !important;
  border-color: #004879 !important;
  color: #FFFFFF !important;
}

/* Disabled button style: match BuildBundleBanner disabled Add to Cart */
.bundle-card__select-btn:disabled,
.bundle-card__select-btn[disabled] {
  background: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
  color: #979797 !important;
  cursor: not-allowed;
}
</style>